const topics = [
  { tag: '奔跑吧', heat: '2.3万讨论', color: 'bg-primary-500/15 text-primary-400 border-primary-500/25' },
  { tag: '歌手2025', heat: '1.8万讨论', color: 'bg-accent-500/15 text-accent-400 border-accent-500/25' },
  { tag: '向往的生活', heat: '1.5万讨论', color: 'bg-primary-500/15 text-primary-400 border-primary-500/25' },
  { tag: '脱口秀大会', heat: '1.2万讨论', color: 'bg-accent-500/15 text-accent-400 border-accent-500/25' },
  { tag: '这就是街舞', heat: '9800讨论', color: 'bg-primary-500/15 text-primary-400 border-primary-500/25' },
  { tag: '密室大逃脱', heat: '8600讨论', color: 'bg-accent-500/15 text-accent-400 border-accent-500/25' },
  { tag: '披荆斩棘', heat: '7900讨论', color: 'bg-primary-500/15 text-primary-400 border-primary-500/25' },
  { tag: '乘风破浪', heat: '7200讨论', color: 'bg-accent-500/15 text-accent-400 border-accent-500/25' },
  { tag: '极限挑战', heat: '6800讨论', color: 'bg-primary-500/15 text-primary-400 border-primary-500/25' },
  { tag: '哈哈哈哈哈', heat: '6100讨论', color: 'bg-accent-500/15 text-accent-400 border-accent-500/25' },
  { tag: '中国好声音', heat: '5800讨论', color: 'bg-primary-500/15 text-primary-400 border-primary-500/25' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-100 mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            大家都在讨论的热门综艺话题，看看哪档节目最受关注
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <a
              key={topic.tag}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className={`whitespace-nowrap px-4 py-2 rounded-full border text-sm font-medium transition-all duration-200 cursor-pointer hover:scale-105 ${topic.color}`}
            >
              <span className="mr-1.5">#</span>{topic.tag}
              <span className="ml-2 text-xs opacity-70">{topic.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}